// Shared smooth-scroll helper.
// Uses the active Lenis instance (exposed on window.__lenis) so programmatic
// scrolling cooperates with Lenis's scroll hijacking. Falls back to native
// scrolling when Lenis is not available.
export const scrollToSection = (id, offset = -80) => {
  const element = document.getElementById(id);
  if (!element) return;

  if (typeof window !== 'undefined' && window.__lenis) {
    window.__lenis.scrollTo(element, { offset, duration: 1.5 });
  } else {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};
